import PropTypes from 'prop-types';
import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import { HEFFALUMP, MARIGOLD_LIGHT, MARIGOLD_MEDIUM, OLAF, OBSIDIAN, GREAT_WHITE } from 'HubStyleTokens/colors';
import SpacingWrapper from '../atoms/SpacingWrapper';
import PositionDescriptors from 'conversations-message-history/proptypes/PositionDescriptors';
import { COMMENT, DEFAULT } from 'conversations-message-history/constants/tileMessageUses';
import { jsx as _jsx } from "react/jsx-runtime";
const borderColors = {
  [COMMENT]: MARIGOLD_MEDIUM,
  [DEFAULT]: GREAT_WHITE
};
const backgroundColors = {
  [COMMENT]: MARIGOLD_LIGHT,
  [DEFAULT]: OLAF
};
const colors = {
  [COMMENT]: HEFFALUMP,
  [DEFAULT]: OBSIDIAN
};
export const TileMessageWrapper = styled(UITile).attrs({
  'data-test-id': 'tile-message-wrapper'
}).withConfig({
  displayName: "TileMessage__TileMessageWrapper",
  componentId: "sc-190yoz0-0"
})(["width:100%;border:solid 1px ", " !important;background-color:", " !important;color:", ";"], ({
  use
}) => borderColors[use], ({
  use
}) => backgroundColors[use], ({
  use
}) => colors[use]);
const TileMessage = ({
  children,
  positionDescriptors,
  use = DEFAULT
}) => {
  if (!children) {
    return null;
  }
  return /*#__PURE__*/_jsx(SpacingWrapper, {
    positionDescriptors: positionDescriptors,
    children: /*#__PURE__*/_jsx(TileMessageWrapper, {
      use: use,
      compact: true,
      children: children
    })
  });
};
TileMessage.displayName = 'TileMessage';
TileMessage.propTypes = {
  children: PropTypes.node,
  positionDescriptors: PositionDescriptors,
  use: PropTypes.oneOf([DEFAULT, COMMENT])
};
export default TileMessage;